import UIAssetKeys from './UIAssetKeys';

export default function setupGameConfig(variantId) {
  const config = {
    // add your game config options here, these can be the default values
    gameMode: null, // null allows the user to pick the game mode, otherwise set to 1 to 7 for the game mode
    subtitle: null, // the subtitle graphic, if any
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
    case 'pre-primer-a': // kindergarten
      config.gameMode = 1;
      config.subtitle = UIAssetKeys._Variants_Pre_Primer;
      break;
    case 'primer-a': // 1st grade
      config.gameMode = 2;
      config.subtitle = UIAssetKeys._Variants_Primer;
      break;
    case 'first-grade-a': // 1st grade
      config.gameMode = 3;
      config.subtitle = UIAssetKeys._Variants_First_Grade;
      break;
    case 'second-grade-a': // 2nd grade
      config.gameMode = 4;
      config.subtitle = UIAssetKeys._Variants_Second_Grade;
      break;
    case 'third-grade-a': // 3rd grade
      config.gameMode = 5;
      config.subtitle = UIAssetKeys._Variants_Third_Grade;
      break;
    case 'nouns-a': // 2nd grade
    case 'nouns-b': // 3rd grade
      config.gameMode = 7;
      config.subtitle = UIAssetKeys._Variants_Nouns;
      break;
  }
  return config;
}